import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-biological-sexes',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-biological-sexes-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-biological-sexes-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-biological-sexes-index" */ '@/modules/configurations/catalogs/catalog-biological-sexes/views/Index.vue')
        }
    ]
}
